import { EntityRepository, Repository } from "typeorm";
import {FgInspection } from "../entities/fg-inspection.entity";

@EntityRepository(FgInspection)
export class FgInspectionRepository extends Repository<FgInspection> {

}